import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Subject} from 'rxjs';
import {Office} from '../../../classes/Office';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {OfficeService} from '../../../services/office.service';
import {Sensor} from '../../../classes/Sensor';
import {RelayBoardService} from '../../../services/relay-board.service';
import {RelayBoard} from '../../../classes/RelayBoard';

@Component({
  selector: 'app-sensor-edit',
  styleUrls: ['./sensor-edit.component.scss'],
  templateUrl: './sensor-edit.component.html',
  encapsulation: ViewEncapsulation.None
})
export class SensorEditComponent implements OnInit {

  @Input() sensor: Sensor;

  destroy = new Subject<any>();
  currentDialog = null;
  errorMessage: string;
  types: string[];
  offices: Office[];
  relayBoards: RelayBoard[];

  public sensorForm: FormGroup;

  constructor(private activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private officeService: OfficeService,
              private relayBoardService: RelayBoardService) {}

  ngOnInit(): void {

    if (this.sensor) {
      this.sensorForm = this.formBuilder.group({
        id: [this.sensor.id],
        officeId: [this.sensor.officeId, Validators.required],
        relayBoardId: [this.sensor.relayBoardId, Validators.required],
        sensorId: [this.sensor.sensorId, Validators.required],
        name: [this.sensor.name, Validators.required]
      });
    } else {
      this.sensorForm = this.formBuilder.group({
        id: [null],
        officeId: [null, Validators.required],
        relayBoardId: [null, Validators.required],
        sensorId: [null, Validators.required],
        name: ['', Validators.required]
      });
    }

    this.sensorForm.controls.officeId.valueChanges.subscribe(value => {
      this.relayBoardService.getAllByOffice(value).subscribe(response => this.relayBoards = response);
    });

    this.officeService.getAll().subscribe({
      next: (response: Office[]) => this.offices = response,
      error: err => console.log(err.error) // TODO handle error
    });

    this.relayBoardService.getAll().subscribe({
      next: (response: RelayBoard[]) => this.relayBoards = response,
      error: err => console.log(err.error) // TODO handle error
    });
  }

  closeModal(sendData): void {
    this.activeModal.close(sendData);
  }
}
